<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-account-multiple</v-icon> <span>{{$t('my_profile.register_title')}}</span>
      </h1>

      <div class="mt-16">
        <user method="create"></user>
      </div>
  </section>
</template>
<script>
import User from '@/components/users/User'

export default {
  components: {
    User
  },
  beforeCreate(){
    document.title = "Report Lake- " + this.$t('my_profile.register_title_plural');
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "users.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.users_management'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin/accesses/users',
          exact: true,
        },
        {
          text: this.$t('my_profile.register_title'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
